import React from "react";
import "./chatItem.css";
import UserProfile from "../../images/user_profile.png";

const ChatItem = (props) => {
  return (
    <div className="Actions user-container">
      <img src={props.user_image? props.user_image : UserProfile} alt={props.username} className="imgUser" />
      <div className="status-active"></div>
      <h4 className="username">{props.username}</h4>
    </div>
  );
};

export default ChatItem;
